import React, { useState } from "react";
import { Search, Menu, X, BookOpen, User, Bell, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "../lms.css";

function getInitials(name = "") {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export default function StudentLmsTopbar({ onMenuClick }) {
  const navigate = useNavigate();
  const [searchVal, setSearchVal] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);

  const userData = (() => {
    try {
      return JSON.parse(localStorage.getItem("userData") || "{}");
    } catch {
      return {};
    }
  })();

  const userName = userData?.admin_name || userData?.school_name || "Student";
  const schoolName = userData?.school_name || "";

  return (
    <header className="lms-topbar">
      {/* Hamburger — mobile only */}
      <button
        className="lms-topbar-icon-btn lms-hamburger"
        onClick={onMenuClick}
        title="Toggle menu"
      >
        <Menu size={18} strokeWidth={2} />
      </button>

      {/* Classic Student Badge & Title */}
      <div className="lms-topbar-left" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "#eff6ff",
            color: "#1c498d",
            padding: "6px 14px",
            borderRadius: "20px",
            fontSize: "13px",
            fontWeight: "600",
            border: "1px solid #bfdbfe",
          }}
        >
          <BookOpen size={16} />
          <span>Student LMS Portal</span>
        </div>
      </div>

      {/* Search Bar */}
      <div className={`lms-topbar-search ${searchOpen ? "lms-topbar-search--open" : ""}`}>
        <span className="lms-topbar-search-icon">
          <Search size={15} strokeWidth={2} />
        </span>
        <input
          type="text"
          placeholder="Search courses, study material..."
          value={searchVal}
          onChange={(e) => setSearchVal(e.target.value)}
        />
        {searchOpen && (
          <button
            className="lms-topbar-search-close"
            onClick={() => setSearchOpen(false)}
          >
            <X size={14} strokeWidth={2} />
          </button>
        )}
      </div>

      {/* Right Side Controls */}
      <div className="lms-topbar-right" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        {/* Mobile search toggle */}
        <button
          className="lms-topbar-icon-btn lms-search-toggle"
          onClick={() => setSearchOpen((o) => !o)}
          title="Search"
        >
          <Search size={16} strokeWidth={2} />
        </button>

        {/* Home Button */}
        <button
          className="lms-topbar-icon-btn"
          onClick={() => navigate("/dashboard")}
          title="Back to Student Home"
          style={{ cursor: "pointer" }}
        >
          <Home size={16} strokeWidth={2} color="#475569" />
        </button>

        {/* User Card */}
        <div className="lms-topbar-user" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            className="lms-topbar-avatar"
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "50%",
              background: "#1c498d",
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "600",
              fontSize: "13px",
            }}
          >
            {getInitials(userName)}
          </div>
          <div className="lms-topbar-user-info" style={{ display: "flex", flexDirection: "column" }}>
            <span className="lms-topbar-name" style={{ fontSize: "13px", fontWeight: "600", color: "#0f172a" }}>
              {userName}
            </span>
            {schoolName && (
              <span className="lms-topbar-role" style={{ fontSize: "11px", color: "#64748b" }}>
                {schoolName}
              </span>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
